import React from 'react';
import { useDispatch } from 'react-redux';
import { Image } from 'react-bootstrap';

import {
  listImage,
  listItem,
  titleForItem,
} from 'components/banners/DisplayItems';
import CustomRichTextViewer from 'components/base/CustomRichTextViewer';
import { WhatsappContentInlineDisplay } from 'components/message/WhatsappContentInlineEditor';
import { WechatContentInlineDisplay } from 'components/message/WechatContentInlineEditor';
import {
  LanguageConfig,
  MessageChannel,
  MessagePushAndInboxSelector,
  MessageWhatsappTemplateType,
} from 'config/CustomEnums';

import './MessageGeneralSectionWhatsapp.scss';
import './MessageGeneralSectionWechat.scss';
import './MessageOverviewTableSection.scss';
import { TitleWithEditButton } from 'components/campaignStreamline/SinglePreviewCard';
import { CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY } from 'config/PageAnchorConfig/CampaignAnchorConfig';

function MessageOverviewTableSection({
  step=1,
  message = {},
  language = LanguageConfig.english,
  isRecurringMessage = false,
  errors = [],
  showEditButton = false,
  prefix = "",
}) {
  const dispatch = useDispatch();

  console.log("@@24", message)
  const channels = message?.channels;

  const defaultChannels = [];
  if (
    (
      channels?.includes(MessageChannel.all) ||
      channels?.includes(MessageChannel.allWhatsapp) ||
      channels?.includes(MessageChannel.allWechat) ||
      channels?.includes(MessageChannel.push) ||
      channels?.includes(MessageChannel.pushAndInbox)
    ) && (
      !isRecurringMessage
      || (isRecurringMessage && message?.pushAndInboxSelector !== MessagePushAndInboxSelector.inbox)
    )
  ) {
    defaultChannels.push(MessageChannel.push);
  }
  if (
    (
      channels?.includes(MessageChannel.all) ||
      channels?.includes(MessageChannel.allWhatsapp) ||
      channels?.includes(MessageChannel.allWechat) ||
      channels?.includes(MessageChannel.inbox) ||
      channels?.includes(MessageChannel.pushAndInbox)
    ) && (
      !isRecurringMessage
      || (isRecurringMessage && message?.pushAndInboxSelector !== MessagePushAndInboxSelector.push)
    )
  ) {
    defaultChannels.push(MessageChannel.inbox);
  }

  const name = message.translations?.[language]?.name;
  const content = message.translations?.[language]?.content;
  const photo = message.translations?.[language]?.photo?.value;

  const emailTitle = message.translations?.[language]?.emailTitle;
  const emailContent = message.translations?.[language]?.emailContent;

  const smsContent = message.translations?.[language]?.smsContent;

  const whatsappTemplate = message.translations?.[language]?.whatsappTemplate;
  const whatsappType =
    message.translations?.[language]?.whatsappTemplate?.headerFormat ||
    MessageWhatsappTemplateType.TEXT;
  const whatsappImage = message.translations?.[language]?.whatsappImage?.value;
  const whatsappHeader = message.translations?.[language]?.whatsappHeader;
  const whatsappBody = message.translations?.[language]?.whatsappBody;

  const wechatTemplate = message.translations?.[language]?.wechatTemplate;
  const wechatBody = message.translations?.[language]?.wechatBody;
  const wechatRedirectPage = message.translations?.[language]?.wechatRedirectPage;

  return (
    <>
      {channels?.includes(MessageChannel.all) ||
        channels?.includes(MessageChannel.allWhatsapp) ||
        channels?.includes(MessageChannel.allWechat) ||
        channels?.includes(MessageChannel.inbox) ||
        channels?.includes(MessageChannel.pushAndInbox) ||
        channels?.includes(MessageChannel.push) ? (
        <>
          <label className="create-section-title message-channel-title">
            {defaultChannels?.toString()?.toUpperCase()}
          </label>
          <TitleWithEditButton
            itemTitle={'Title'}
            showEditButton={showEditButton}
            errors={errors}
            errorField={`${prefix}translations.${language}.name`}
            isMandatory={false}
            dispatch={dispatch}
            step={step}
            sectionKey={CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.recurringMessage.sectionKey}
          />
          <label className="banners-detail-text">{name || '-'}</label>

          <TitleWithEditButton
            itemTitle={'Content'}
            showEditButton={showEditButton}
            errors={errors}
            errorField={`${prefix}translations.${language}.content`}
            isMandatory
            dispatch={dispatch}
            step={step}
            sectionKey={CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.recurringMessage.sectionKey}
          />
          <CustomRichTextViewer initialValue={content || '-'} />
          {photo == null || photo === ''
            ? listItem('Image (optional)', '-')
            : listImage('Image (optional)', photo)}
        </>
      ) : null}
      {channels?.includes(MessageChannel.all) ||
        channels?.includes(MessageChannel.allWhatsapp) ||
        channels?.includes(MessageChannel.allWechat) ||
        channels?.includes(MessageChannel.email) ? (
        <>
          <label className="create-section-title message-channel-title">{'EMAIL'}</label>
          <TitleWithEditButton
            itemTitle={'Title'}
            showEditButton={showEditButton}
            errors={errors}
            errorField={`${prefix}translations.${language}.emailTitle`}
            isMandatory
            dispatch={dispatch}
            step={step}
            sectionKey={CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.recurringMessage.sectionKey}
          />
          <label className="banners-detail-text">{emailTitle || '-'}</label>

          <TitleWithEditButton
            itemTitle={'Content'}
            showEditButton={showEditButton}
            errors={errors}
            errorField={`${prefix}translations.${language}.emailContent`}
            isMandatory
            dispatch={dispatch}
            step={step}
            sectionKey={CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.recurringMessage.sectionKey}
          />
          <CustomRichTextViewer initialValue={emailContent || '-'} />
        </>
      ) : null}
      {channels?.includes(MessageChannel.all) ||
        channels?.includes(MessageChannel.sms) ? (
        <>
          <label className="create-section-title message-channel-title">{'SMS'}</label>
          <TitleWithEditButton
            itemTitle={'Content'}
            showEditButton={showEditButton}
            errors={errors}
            errorField={`${prefix}translations.${language}.smsContent`}
            isMandatory
            dispatch={dispatch}
            step={step}
            sectionKey={CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.recurringMessage.sectionKey}
          />
          <CustomRichTextViewer initialValue={smsContent || '-'} />
        </>
      ) : null}
      {channels?.includes(MessageChannel.allWhatsapp) ||
        channels?.includes(MessageChannel.whatsapp) ? (
        <>
          <label className="create-section-title message-channel-title">{'Whatsapp'}</label>
          <TitleWithEditButton
            itemTitle={'Whatsapp template'}
            showEditButton={showEditButton}
            errors={errors}
            errorField={`${prefix}translations.${language}.whatsappTemplate`}
            isMandatory
            dispatch={dispatch}
            step={step}
            sectionKey={CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.recurringMessage.sectionKey}
          />
          <label className="banners-detail-text">{whatsappTemplate?.name || '-'}</label>

          <TitleWithEditButton
            itemTitle={'Image'}
            showEditButton={showEditButton}
            errors={errors}
            errorField={`${prefix}translations.${language}.whatsappImage`}
            isMandatory
            dispatch={dispatch}
            step={step}
            sectionKey={CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.recurringMessage.sectionKey}
          />

          {whatsappImage == null || whatsappImage === ''
            ? <label className="banners-detail-text">{'-'}</label>
            : <Image className="feature-campaign-detail-image" src={whatsappImage} />
          }

          <TitleWithEditButton
            itemTitle={'Content'}
            showEditButton={showEditButton}
            errors={errors}
            errorField={`${prefix}channel.Whatsapp`}
            isMandatory
            dispatch={dispatch}
            step={step}
            sectionKey={CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.recurringMessage.sectionKey}
          />
          <WhatsappContentInlineDisplay
            customStyle={'header'}
            contentText={whatsappTemplate?.headerText}
            textArgs={whatsappHeader}
          />
          <WhatsappContentInlineDisplay
            customStyle={'body'}
            contentText={whatsappTemplate?.bodyText}
            textArgs={whatsappBody}
          />
          <WhatsappContentInlineDisplay
            customStyle={'footer'}
            contentText={whatsappTemplate?.footerText}
            textArgs={[]}
          />
        </>
      ) : null}
      {channels?.includes(MessageChannel.allWechat) ||
        channels?.includes(MessageChannel.wechat) ? (
        <>
          <label className="create-section-title message-channel-title">{'WeChat'}</label>
          <TitleWithEditButton
            itemTitle={'WeChat template'}
            showEditButton={showEditButton}
            errors={errors}
            errorField={`${prefix}translations.${language}.wechatTemplate`}
            isMandatory
            dispatch={dispatch}
            step={step}
            sectionKey={CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.recurringMessage.sectionKey}
          />
          <label className="banners-detail-text">{wechatTemplate?.name || '-'}</label>

          <TitleWithEditButton
            itemTitle={'Content'}
            showEditButton={showEditButton}
            errors={errors}
            errorField={`${prefix}channel.WeChat`}
            isMandatory
            dispatch={dispatch}
            step={step}
            sectionKey={CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.recurringMessage.sectionKey}
          />

          <WechatContentInlineDisplay
            customStyle={'body'}
            contentText={wechatTemplate?.content?.trimEnd()}
            textArgs={wechatBody}
          />
          {listItem('Redirect Page (optional)', wechatRedirectPage || '-')}
        </>
      ) : null}
    </>
  );
}

export default MessageOverviewTableSection;
